import React from 'react'
import styled from 'styled-components'
import { WidgetContext } from 'live/context/widget'
import i18n from 'live/services/i18n'
import globalNotification from 'live/services/global-notification'
import Markers from '../index'

export default function Button(props: { closeAll: () => null }): JSX.Element {
    const { chart } = React.useContext(WidgetContext)
    const altKey = (window?.navigator?.platform || '').match(/mac/gi) ? 'Option' : 'Alt'

    return (
        <StyledButton
            onClick={() => {
                props.closeAll()
                Markers.turnMarkerModeOn(chart)
                globalNotification.success(<div>{i18n('marker_widget_action_msg')}</div>, false, true, 'sm', {
                    className: 'alert-sm success marker large'
                })
            }}
        >
            <div>
                <i className="far fa-thumbtack" />
                <span>{i18n('Marker tool')}</span>
            </div>
            <span className="shortcut">{altKey} + Click</span>
        </StyledButton>
    )
}

const StyledButton = styled.div`
    padding-left: 2px;
    margin-top: 10px;
    cursor: pointer;
    display: flex;
    width: 100%;
    div {
        flex: 1;
    }
    span {
        color: var(--static-gray-100);
        font-size: 14px;
    }
    i {
        color: var(--static-blue-500);
        font-size: 14px !important;
        margin-right: 10px;
    }

    .shortcut {
        color: #c8ccd4;
    }
`
